import { buildVersion, buildTimestamp } from './build';

export const environment = {
    // Environment
    production: true,
    env: 'Stage',
    // Build
    version: buildVersion,
    buildTimestamp,
    // API
    apiUrl: '/api/v1',
    apiBaseUrl: '/api',
    gtmId: 'GTM-5G6JZVDG',
    staticResourcePath: 'https://stage-static.crsrescore.org'
};
